import React from "react";
import Navbar from "../components/Navbar";
import Banners from "../components/Banners";
import Whatsapp from "../components/Whatsapp";
import Testimonials from "../components/Testimonials";
import "../assets/css/font-awesome/all.min.css"; 
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/magnific-popup/magnific-popup.css";
import "../assets/css/style.css"; 
import parking from "../assets/images/parking.png";
import swimmingPool from "../assets/images/swimming-pool.png";
import security from "../assets/images/security.png";
import medicalCenter from "../assets/images/medical.png";
import plantation from "../assets/images/plantation.png";
import clubhouse from "../assets/images/park.png";
import park from "../assets/images/club.png";
import playground from "../assets/images/playground.png";
// import banner1 from "../assets/images/banner1.jpg";
import buildingBg from "../assets/images/building-bg.png";
import aboutImage from "../assets/images/about.jpg";
import plotImage from "../assets/images/plot.png";
import villaImage from "../assets/images/villa.png";
import apartmentImage from "../assets/images/apartment.png";
import Footer from "../components/Footer";


const amenities = [
  { id: 1, title: "Parking Space", image: parking },
  { id: 2, title: "Swimming Pool", image: swimmingPool },
  { id: 3, title: "Private Security", image: security },
  { id: 4, title: "Medical Center", image: medicalCenter },
  { id: 5, title: "Avenue Plantations", image: plantation },
  { id: 6, title: "Park", image: park },
  { id: 7, title: "Club House", image: clubhouse },
  { id: 8, title: "Kid’s Playland", image: playground },
];

const featuredProjects = [
  { title: "Premium Plots", description: "Well-planned spaces for the home you have always imagined.", image: plotImage },
  { title: "Modern Villas", description: "Comfortable, private homes designed for relaxed family living.", image: villaImage },
  { title: "Smart Apartments", description: "Connected urban living with thoughtful layouts and amenities.", image: apartmentImage },
];


const Home = () => {
  return (
    <div>
    <Navbar />
    <div className="projects-banner">
        <Banners />
      </div>

      <section className="py-5 mt-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="custom-heading">ABOUT DEVI VINAYAKA BUILDERS</h1>
              <p className="custom-text" style={{ fontSize: "20px", fontWeight: "400" }}>
                Creating opportunities for a better future, Devi Vinayaka Builders has earned a trusted name in the real 
                estate sector by consistently delivering quality and value. Driven by the trust of our clients, the support 
                of our partners, and the dedication of our team, we remain committed to excellence at every step. With a 
                focus on transparency, ethical business practices, and customer satisfaction, we ensure a seamless and 
                rewarding investment experience. Our expert team is here to guide you, making the journey of finding the 
                perfect property smooth and hassle-free.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img src={aboutImage} alt="Real Estate" className="custom-img"/>
            </div>
          </div>
        </div>
      </section>

      {/* Building Amenities Section */}
      <section className="building-amenities py-5 bg-light">
        <div className="container">
          <h2 className="text-center section-title">Our Amenities</h2>
          <p className="custom-text text-center">
            Explore the best-in-class amenities that we offer to make your living experience exceptional.
          </p>
          <div className="row">
            {amenities.map((amenity) => (
              <div key={amenity.id} className="col-md-3 mb-4">
                <div className="card text-center p-3 shadow-sm">
                  <div className="card-body">
                    <img src={amenity.image} alt={amenity.title} className="small-icon"/>
                    <h5 className="card-title mt-3">{amenity.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* reasons to choose us */}
      <section className="space-ptb bg-holder-bottom building-space" style={{ backgroundImage: `url(${buildingBg})` }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <div className="section-title mb-0s">
                <h2>Reasons To Choose Us</h2>
              </div>
            </div>
            <div className="col-lg-3 text-lg-end">
              <a className="btn btn-success" href="/about">More about us </a>
            </div>
          </div>
          <div className="row g-0 mt-4">
            <div className="col-lg-3 col-sm-6">
              <div className="feature-info h-100">
                <div className="feature-info-icon">
                  <i className="flaticon-like"></i>
                </div>
                <div className="feature-info-content">
                  <h6 className="mb-3 feature-info-title">Excellent reputation</h6>
                  <p className="mb-0">Our comprehensive database of listings and market info give the most accurate view of the market and your home value.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-info h-100">
                <div className="feature-info-icon">
                  <i className="flaticon-agent"></i>
                </div>
                <div className="feature-info-content">
                  <h6 className="mb-3 feature-info-title">Best local agents</h6>
                  <p className="mb-0">You are just minutes from joining with the best agents who are fired up about helping you Buy or sell.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-info h-100">
                <div className="feature-info-icon">
                  <i className="flaticon-like-1"></i>
                </div>
                <div className="feature-info-content">
                  <h6 className="mb-3 feature-info-title">Peace of mind</h6>
                  <p className="mb-0">Rest guaranteed that your agent and their expert team are handling every detail of your transaction from start to end.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-info h-100">
                <div className="feature-info-icon">
                  <i className="flaticon-house-1"></i>
                </div>
                <div className="feature-info-content">
                  <h6 className="mb-3 feature-info-title">Tons of options</h6>
                  <p className="mb-0">Discover a place you’ll love to live in. Choose from our vast inventory and choose your desired house.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-projects-section">
        <div className="container">
          <div className="featured-projects-heading">
            <div>
              <span className="home-lifestyle-eyebrow">FIND YOUR NEXT ADDRESS</span>
              <h2>Explore our projects</h2>
            </div>
            <a href="/Projects" className="featured-projects-link">
              View all projects <span aria-hidden="true">&#8594;</span>
            </a>
          </div>
          <div className="featured-projects-grid">
            {featuredProjects.map((project) => (
              <article className="featured-project-card" key={project.title}>
                <img src={project.image} alt={project.title} />
                <div className="featured-project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <a href="/Projects" aria-label={`Learn more about ${project.title}`}>
                    Discover more <span aria-hidden="true">&#8594;</span>
                  </a>
                </div>
              </article>
            ))}
          </div>
          <div className="home-trust-strip">
            <div><strong>100%</strong><span>Transparent process</span></div>
            <div><strong>24/7</strong><span>Customer support</span></div>
            <div><strong>4+</strong><span>Property choices</span></div>
            <div><strong>1</strong><span>Trusted team</span></div>
          </div>
        </div>
      </section>

      <section className="home-lifestyle-section">
        <div className="container">
          <div className="home-lifestyle-grid">
            <div className="home-lifestyle-intro">
              <span className="home-lifestyle-eyebrow">MORE THAN A PROPERTY</span>
              <h2>Designed for the way you want to live.</h2>
              <p>
                From everyday convenience to lasting value, every detail is planned
                to help you feel at home from the moment you arrive.
              </p>
              <a href="/contact" className="home-lifestyle-button">
                Talk to our team <span aria-hidden="true">&#8594;</span>
              </a>
            </div>
            <div className="home-lifestyle-points">
              <div className="home-lifestyle-point">
                <span className="home-lifestyle-number">01</span>
                <div>
                  <h3>Thoughtful planning</h3>
                  <p>Well-planned spaces that make daily life simpler and more comfortable.</p>
                </div>
              </div>
              <div className="home-lifestyle-point">
                <span className="home-lifestyle-number">02</span>
                <div>
                  <h3>Built for tomorrow</h3>
                  <p>Quality infrastructure and dependable essentials for long-term value.</p>
                </div>
              </div>
              <div className="home-lifestyle-point">
                <span className="home-lifestyle-number">03</span>
                <div>
                  <h3>Guidance you can trust</h3>
                  <p>Clear communication and expert support throughout your property journey.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <div className="mt-5">
        <Testimonials />
      </div>

      <Whatsapp />
    <Footer/>
  </div>
  );
};
export default Home;